// extracted by mini-css-extract-plugin
export default {"carousel":"styles_carousel__th4ri","inner":"styles_inner__iTkrs","status":"styles_status__G50cn"};